import { getLogConfig } from '#core/utils/logger'

export const pwa = {
  enabled: process.env.FEATURE_PWA !== 'false',
  installPrompt: process.env.PWA_INSTALL_PROMPT === 'true',
  dev: process.env.PWA_DEV === 'true'
}

export const htmlValidator = {
  enabled: process.env.FEATURE_HTML_VALIDATOR !== 'false'
}

export const gtm = {
  enabled: process.env.FEATURE_GTM !== 'false'
}

export const devtools = {
  enabled: process.env.FEATURE_DEVTOOLS !== 'false'
}

export const logger = getLogConfig()

export const storybook = {
  enabled: process.env.STORYBOOK === 'true'
}
